import styled from "styled-components";

import { StyledEditModalContent } from "@pages/Patients/Laboratory/components/EditModal/EditModal.styled";


export const StyledAddFileModalContent = styled(StyledEditModalContent)`
  .dropzone {
    &.disabled {
      cursor: unset;
      background-color: var(--clr-gray-100);
      border: 1px dashed var(--clr-gray-200);

      .text-content {
        .svg-wrapper {
          background-color: var(--clr-gray-150);

          svg {
            color: var(--clr-gray-400);
          }
        }
        .p-wrapper {
          p:first-child {
            color: var(--clr-gray-300);
          }
          p:last-child {
            color: var(--clr-gray-200);
          }
        }
      }
    }
  }
`;
